<template>
    <FullFillBox
        :pageID="1003"
        @permissionData="(data) => {
            this.permissionDetails = data
        }"
    >
        <h4>{{ $t('inventory_stock_out') }}</h4>
        <hr>
        <form @submit.prevent="dataToTable">
            <TopDataKeyBox
                ref="topDataKeyBox"
                :key-label="this.$t('inventory_stock_out_dn')"
                :key-remarks-label="this.$t('inventory_stock_in_remarks')"
                :mode="'stock_out'"
                @returnData="returnDataFromKeyComponents"
            />
            <hr>
            <div class="row">
                <div class="col-lg-4">
                    <div class="row">
                        <div class="col-lg-2 col-form-label" style="text-align: left">
                            {{ $t('inventory_stock_out_department') }}
                        </div>
                        <div class="col-lg-10">
                            <Multiselect
                                v-model="getDepartment"
                                :options="departmentList"
                                mode="single"
                                :can-clear=true
                                :searchable="true"
                                :create-option="true"
                                :placeholder="this.$t('inventory_stock_out_select_department') + ' (' + this.departmentList.length + ')'"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="row">
                        <div class="col-lg-2 col-form-label" style="text-align: left">
                            {{ $t('inventory_stock_out_driver') }}
                        </div>
                        <div class="col-lg-10">
                            <Multiselect
                                v-model="getDriver"
                                :options="driverList"
                                mode="single"
                                :can-clear=true
                                :searchable="true"
                                :placeholder="this.$t('inventory_stock_out_select_driver') + ' (' + this.driverList.length + ')'"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="row">
                        <div class="col-lg-4 col-form-label" style="text-align: left">
                            {{ $t('inventory_stock_out_date') }}
                        </div>
                        <div class="col-lg-8">
                            <input class="form-control" type="date" v-model="getStockOutDate">
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <FilterMainContentBox
                ref="filterMainContentBox">
                <FilterDetailContentBox
                    ref="filterDetailContentBox"
                    :mode="'need'"
                    :update-mode="this.updateMode"
                    @cancelUpdateMode="cancelUpdateMode"
                    @returnProductData="doStuff2"
                >
                    <slot>
                        <!--                            :productID="this.getComponentProduct['productID']"-->
                        <StockCalculatedLocationBox
                            key="stockCalculatedLocationBox"
                            ref="stockCalculatedLocationBox"
                            :getTime="this.randomNumber"
                            :stockOutTempID="this.getStockOutID"
                            :productID="this.getComponentProduct['id']"
                            @loc="(returnData) => {
                                this.canInputNumber = true
                                this.getLocationDetails = returnData
                                if(this.getLocationDetails){
                                    this.getNowCanUseQty = returnData['qty'] - returnData['stockOutTempQty2'] - returnData['transTempQty2']
                                }else{
                                    this.getNowCanUseQty = 0
                                }
                                this.$refs.qtyProcessor.getFocus()
                            }"
                        />
                        <QtyProcessor
                            ref="qtyProcessor"
                            :ctn-qty="this.ctnQty"
                            :flag="this.canInputNumber"
                            @returnQty="(returnData)=>{
                                this.getQty = returnData['qty']
                                this.getCtn = returnData['ctn']
                                if(this.getQty > this.getNowCanUseQty){
                                    this.$swal.fire({
                                        title: this.$t('error_stock_not_enough'),
                                        text: this.$t('error_stock_not_enough_details') + this.getNowCanUseQty + ', ' +
                                              this.$t('error_stock_not_enough_get') + this.getQty,
                                        icon: 'warning'
                                    })
                                    this.$refs.qtyProcessor.clearMode()
                                }
                            }"
                            style="margin-top: 5px;"
                        />
                        <div class="row" style="margin-top: 5px">
                            <div class="col-lg-2 col-form-label" style="text-align: left">
                                {{ $t('inventory_stock_in_remarks') }}
                            </div>
                            <div class="col-lg-10"><input class="form-control" v-model="getRemarks"></div>
                        </div>
                    </slot>
                </FilterDetailContentBox>
            </FilterMainContentBox>
        </form>
        <hr>

        <div id="error_show" style="display: none">
            <p>{{ mainError }}</p>
            <p>
                <button class="btn btn-warning" type="button"
                        data-bs-toggle="collapse" data-bs-target="#collapseExample"
                        aria-expanded="false" aria-controls="collapseExample">
                    {{ $t('error_expand_error_details') }}
                </button>
            </p>
            <div class="collapse" id="collapseExample">
                <div id="errorDetailList"></div>
            </div>
        </div>

        <div ref="tabulatorTableUse"></div>
        <div class="row">
            <div class="col-md-4">
                <button class="btn btn-primary"
                        @click="uploadToServer"
                        style="width: 200px;margin: auto auto 5px auto">
                    {{ $t('common_upload') }}
                </button>

            </div>
            <div class="col-md-4 order-md-first">
                <button class="btn" v-if="getStockOutID === null"
                        @click="saveOrUpdateTemp"
                        style="background-color: purple;color:white;width: 200px;margin: auto auto 5px auto">
                    {{ $t('inventory_stock_out_temp_save') }}
                </button>
                <button class="btn" v-else
                        @click="saveOrUpdateTemp"
                        style="background-color: purple;color:white;width: 200px;margin: auto auto 5px auto">
                    {{ $t('inventory_stock_out_temp_save2') }}
                </button>
            </div>
            <div class="col-md-4">
                <button class="btn"
                        @click="listTemp"
                        style="background-color: purple;color:white;width: 200px;margin: auto auto 5px auto">
                    {{ $t('inventory_stock_out_temp_list') }}
                </button>
            </div>
        </div>
    </FullFillBox>

    <!--   PopupMenu Show Saving Confirm Box  -->
    <vue-final-modal v-model="showTempSavePopUp" classes="modal-container" content-class="modal-content"
                     style="margin-top: 20vh;margin-right: 5%;margin-left: 5%;height: 10px">
        <button class="modal__close" @click="tempSaveClose">
            <i class="bi bi-x-lg"></i>
        </button>
        <span class="modal__title"></span>
        <div class="modal__content" style="background-color: white;border: black solid 3px;height: auto;width: auto">
            <div style="margin: 5px">
                <h4 v-if="getStockOutID === null">{{ $t('inventory_stock_out_temp_add') }}</h4>
                <h4 v-else>{{ $t('inventory_stock_out_temp_update') }}</h4>
                <hr>
                <div class="row">
                    <div class="col-md-6">
                        <div class="row" style="margin-top: 5px">
                            <div class="col-lg-3 col-form-label" style="text-align: left">
                                {{ $t('inventory_stock_out_dn') }}
                            </div>
                            <div class="col-lg-9"><input class="form-control" v-model="getDN" disabled></div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row" style="margin-top: 5px">
                            <div class="col-lg-3 col-form-label" style="text-align: left">
                                {{ $t('inventory_stock_in_remarks') }}
                            </div>
                            <div class="col-lg-9"><input class="form-control" v-model="getDNRemarks" disabled></div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="row" style="margin-top: 5px">
                            <div class="col-lg-3 col-form-label" style="text-align: left">
                                {{ $t('inventory_stock_out_date') }}
                            </div>
                            <div class="col-lg-9"><input class="form-control" type="date" v-model="getStockOutDate" disabled></div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row" style="margin-top: 5px">
                            <div class="col-lg-3 col-form-label" style="text-align: left">
                                {{ $t('inventory_stock_out_temp_record') }}
                            </div>
                            <div class="col-lg-9"><input class="form-control" v-model="getTableTotalRecord" disabled></div>
                        </div>
                    </div>
                </div>
                <div v-if="getStockOutID === null" style="margin-top: 5px">
                    <button class="btn btn-primary" style="width: 90%;margin: auto" @click="tempListProcess">{{ $t('common_save') }}</button>
                </div>
                <div v-else>
                    <button class="btn btn-primary" style="width: 90%;margin: auto" @click="tempListProcess">{{ $t('common_update') }}</button>
                </div>
            </div>
        </div>
    </vue-final-modal>

    <!--   PopupMenu Show Temp List  -->
    <vue-final-modal v-model="showTempListPopUp" classes="modal-container" content-class="modal-content"
                     style="margin-top: 10vh;margin-right: 5%;margin-left: 5%;height: 10px">
        <button class="modal__close" @click="tempListClose">
            <i class="bi bi-x-lg"></i>
        </button>
        <span class="modal__title"></span>
        <div class="modal__content" style="background-color: white;border: black solid 3px;height: 80vh;width: auto">
            <StockOutTempListBox
                v-if="showTempListPopUp"
                @clickedOnTemp="openOldTempRecord"
            />
        </div>
    </vue-final-modal>

</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import TopDataKeyBox from "@/components/StockProcessComponents/TopDataKeyBox";
import FilterMainContentBox from "@/components/StockProcessComponents/FilterMainContentBox";
import FilterDetailContentBox from "@/components/StockProcessComponents/FilterDetailContentBox";
import QtyProcessor from "@/components/StockProcessComponents/QtyProcessor";
import Multiselect from "@vueform/multiselect";
import StockCalculatedLocationBox from "@/components/StockProcessComponents/StockCalculatedLocationBox";
import {TabulatorFull as Tabulator} from "tabulator-tables";
import StockOutTempListBox from "@/components/StockProcessComponents/StockOutTempListBox";

export default {
    name: "InventoryStockOutView",
    components: {
        Multiselect,
        FullFillBox,
        TopDataKeyBox,
        FilterMainContentBox,
        FilterDetailContentBox,
        QtyProcessor,
        StockCalculatedLocationBox,
        StockOutTempListBox,
    },
    data(){
        return{
            permissionDetails: {},
            getStockOutID: null,

            getDN: '',
            getDNRemarks: '',
            getStockOutDate: '',

            getDriver: '',
            driverList: [],
            getDepartment: '',
            departmentList: [],
            getCtn: '',
            getQty: '',
            getRemarks: '',
            canInputNumber: false,

            // loc
            needReloadList: '',
            randomNumber: '',
            getLocationDetails: null,
            getNowCanUseQty: '',

            // each same time
            updateMode: false,
            updateItemID: '',
            getComponentProduct: '',
            ctnQty: null,
            tablePKID: 1,

            // Temp Save Table
            showTempListPopUp: false,
            showTempSavePopUp: false,
            getTableTotalRecord: '',

            //error
            mainError: '',
        }
    },
    methods: {
        doStuff2(getProduct){
            if(getProduct.status === 0){
                this.ctnQty = null
                this.$refs.stockCalculatedLocationBox.clearData()
            }else{
                // use to let 'watch' to update the data
                if(this.needReloadList === false){
                    this.needReloadList = true
                }else{
                    this.randomNumber = new Date()
                }
                this.getComponentProduct = getProduct.details
                this.ctnQty = getProduct.details.out_pack
            }
        },
        cancelUpdateMode(res){
            this.updateMode = false
            this.clearInputData()
        },
        openOldTempRecord(getData){
            this.tablePKID += getData['details'].length
            this.tabulator.setData(getData['details'])
            this.getStockOutID = getData['sid']
            this.$refs.topDataKeyBox.updateFromParent(getData['dn'])
            this.$store.commit('setIsBlackLayout', false)
            this.showTempListPopUp = false
        },
        listTemp(){
            this.$store.commit('setIsBlackLayout', true)
            this.showTempListPopUp = true
        },
        returnDataFromKeyComponents(returnData){
            this.getDN = returnData['key']
            this.getDNRemarks = returnData['keyRemarks']
            if(returnData['isExist'] === true){
                this.getStockOutDate = returnData['existModelData']['stockOutDate'].split('T')[0]
                this.getDepartment = returnData['existModelData']['dep_name']
                this.getDriver = returnData['existModelData']['driverFK']
                this.getStockOutID = returnData['existModelData']['id']
            }
        },
        async uploadToServer(){
            if(this.tabulator.getData().length === 0 || this.getDN.length === 0 || this.getDriver.length === 0){
                this.$swal.fire({
                    title: this.$t('inventory_stock_out_required_field'),
                })
            }else{
                let data = {
                    'mode': 'add',
                    'dn': this.getDN,
                    'dnRemarks': this.getDNRemarks,
                    'department': this.getDepartment,
                    'driver': this.getDriver,
                    'stockOutDate': this.getStockOutDate,
                    'details': this.tabulator.getData()
                }
                await this.dataToBackend(data)
            }
        },
        async tempListProcess() {
            let data = {
                'mode': 'temp',
                'dn': this.getDN,
                'dnRemarks': this.getDNRemarks,
                'department': this.getDepartment,
                'driver': this.getDriver,
                'stockOutDate': this.getStockOutDate,
                'details': this.tabulator.getData()
            }
            await this.dataToBackend(data)
        },
        async dataToBackend(data){
            await this.$mainApi.post('api/inventory/stock-out-temp/', data)
                .then(async response => {
                    this.tempSaveClose()
                    let parent = document.getElementById('errorDetailList')
                    // clear old errors
                    parent.innerHTML = ""
                    if (response.data.status === 80) {
                        if (response.data.details.errors.error_row.length > 0) {
                            document.getElementById('error_show').style.display = 'block'
                            // Have Errors
                            // this.tabulator.setData(
                            //     response.data.details.data.filter(a => response.data.details.errors.error_row.includes(a.id)))
                            this.tabulator.setData(response.data.details.data)
                            let getErrorList = response.data.details.errors.error_details
                            for (let i = 0; i < getErrorList.length; i++) {
                                let htmlContent = await this.$serverErrorReturn(getErrorList[i]['details'])
                                let subParent =
                                    "<div class='row' style='background-color: #d4d5e5;border: solid grey 1px;border-radius: 15px'>" +
                                    "<div class='col-3 my-auto'>" +
                                    "<h4><strong>" + this.$t('common_row') + " " + getErrorList[i]['id'] + "</strong></h4>" +
                                    "</div>" +
                                    "<div class='col-9'>" +
                                    "<p>" + getErrorList[i]['errors'] + "</p>" +
                                    htmlContent +
                                    "</div>" +
                                    "</div><br>"
                                parent.innerHTML += subParent
                            }
                        }else{
                            this.$toast.success(this.$t('common_success'))
                            this.$router.go(0)
                        }
                    }else{
                        document.getElementById('error_show').style.display = 'block'
                        this.mainError = response.data.errors
                        let getErrorList = response.data.details
                        let htmlContent = await this.$serverErrorReturn(getErrorList)
                        let subParent =
                            "<div class='row' style='background-color: #d4d5e5;border: solid grey 1px;border-radius: 15px'>" +
                            "<div class='col-12'>" + htmlContent + "</div>" +
                            "</div><br>"
                        parent.innerHTML += subParent
                    }
                })
        },
        saveOrUpdateTemp(){
            let data = this.tabulator.getData()
            if(data.length > 0 && this.getDN.length > 0){
                this.$store.commit('setIsBlackLayout', true)
                this.getTableTotalRecord = data.length
                this.showTempSavePopUp = true
            }else{
                this.$swal.fire({
                    title: this.$t('inventory_stock_out_required_field'),
                    icon: 'warning'
                })
            }
        },
        tempListClose(){
            this.$store.commit('setIsBlackLayout', false)
            this.showTempListPopUp = false
        },
        tempSaveClose(){
            this.$store.commit('setIsBlackLayout', false)
            this.showTempSavePopUp = false
        },
        notEnough(nowCanUse, getNowQty){
            this.$swal.fire({
                title: this.$t('error_stock_not_enough'),
                text: this.$t('error_stock_not_enough_details') + nowCanUse + ', ' +
                    this.$t('error_stock_not_enough_get') + getNowQty,
                icon: 'warning'
            })
            this.$refs.qtyProcessor.clearMode()
        },
        dataToTable(){
            let data = this.tabulator.getData()
            if(this.getComponentProduct['id'] && this.getLocationDetails['id'] && this.getCtn && this.getQty){
                // 1. Get All Same LocID and Product ID Items' Total Qty
                let isError = false

                let totalQtyCheck = data.filter(a=>
                    a.pid === this.getComponentProduct['id'] &&
                    a.lid === this.getLocationDetails['id'])
                if(this.updateMode === true){
                    // Don't calculate myself
                    totalQtyCheck = data.filter(a=>
                        a.pid === this.getComponentProduct['id'] &&
                        a.lid === this.getLocationDetails['id'] &&
                        a.id !== this.updateItemID)
                }

                // If all other same item qty + now input Qty is larger than Inv Can Use Qty = Error
                let totalExistedQty = 0
                for(let i=0;i<totalQtyCheck.length;i++){
                    totalExistedQty += totalQtyCheck[i]['qty']
                }
                if(this.getQty + totalExistedQty > this.getNowCanUseQty){
                    this.notEnough(this.getNowCanUseQty, this.getQty + totalExistedQty)
                    isError = true
                }

                if(isError === false){
                    let duplicateData = 0
                    if(this.updateMode === false){
                        duplicateData = data.findIndex(a=>
                            a.pid === this.getComponentProduct['id'] &&
                            a.lid === this.getLocationDetails['id'] &&
                            a.remarks === this.getRemarks)
                    }else if(this.updateMode === true){
                        duplicateData = data.findIndex(a=>
                            a.pid === this.getComponentProduct['id'] &&
                            a.lid === this.getLocationDetails['id'] &&
                            a.remarks === this.getRemarks &&
                            a.id !==  this.updateItemID)
                    }

                    if(duplicateData === -1){
                        // No Same Data, add NEW
                        data.push({
                            "id": this.tablePKID,
                            "pid": this.getComponentProduct['id'],
                            "lid": this.getLocationDetails['id'],
                            "outCode": this.getComponentProduct['outCode'],
                            "innerCode": this.getComponentProduct['innerCode'],
                            "product_name": this.getComponentProduct['name_en'],
                            "location_name": this.getLocationDetails['location'] + ' ' + this.getLocationDetails['area'],
                            "qty": this.getQty,
                            "ctn": this.getCtn,
                            "remarks": this.getRemarks,
                        })

                        // if update mode, add new then delete old myself
                        if(this.updateMode === true){
                            data = data.filter(a => a.id !== this.updateItemID)
                        }
                    }else if(duplicateData > -1){
                        // Has Same Data, update OLD
                        if(this.updateMode === true) {
                            // update old data to new
                            let newData = {
                                "id": data[duplicateData]['id'],
                                "pid": this.getComponentProduct['id'],
                                "lid": this.getLocationDetails['id'],
                                "outCode": this.getComponentProduct['outCode'],
                                "innerCode": this.getComponentProduct['innerCode'],
                                "product_name": this.getComponentProduct['name_en'],
                                "location_name": this.getLocationDetails['location'] + ' ' + this.getLocationDetails['area'],
                                "qty": this.getQty + data[duplicateData]['qty'],
                                "ctn": Math.round((this.getQty + data[duplicateData]['qty']) / this.ctnQty * 10000) / 10000,
                                "remarks": this.getRemarks,
                            }
                            data[duplicateData] = {
                                ...data[duplicateData],
                                ...newData
                            }

                            // if update mode, add new then delete old myself
                            data = data.filter(a => a.id !== this.updateItemID)

                        }else if(this.updateMode === false) {
                            // old data add new data (But no need delete myself, cuz no myself)
                            // let gotTheItem = false
                            data[duplicateData] = {
                                "id": data[duplicateData]['id'],
                                "pid": this.getComponentProduct['id'],
                                "lid": this.getLocationDetails['id'],
                                "outCode": this.getComponentProduct['outCode'],
                                "innerCode": this.getComponentProduct['innerCode'],
                                "product_name": this.getComponentProduct['name_en'],
                                "location_name": this.getLocationDetails['location'] + ' ' + this.getLocationDetails['area'],
                                "qty": this.getQty + data[duplicateData]['qty'],
                                "ctn": Math.round((this.getQty + data[duplicateData]['qty']) / this.ctnQty * 10000) / 10000,
                                "remarks": this.getRemarks,
                            }
                        }
                    }
                    this.tablePKID += 1
                    this.tabulator.setData(data)
                    this.clearInputData()
                    this.updateMode = false
                }else{
                    console.log("Error on stock out add to table")
                }
            }else{
                this.$swal.fire({
                    title: this.$t('error_input_stock_in_field_required'),
                    icon: "warning"
                })
            }
        },
        clearInputData(){
            this.getQty = ""
            this.getCtn = ""
            this.getRemarks = ""
            this.$refs.qtyProcessor.clearMode()
            this.canInputNumber = false
            this.$refs.filterDetailContentBox.resetProductSearch()
            this.$refs.stockCalculatedLocationBox.clearData()
        },
        async getBackendData(){
            await this.$mainApi.get('api/other-details/processor?type=department')
                .then(response => {
                    if(response.data.status === 80){
                        let data = response.data.details.returnData
                        for(let i=0;i<data.length;i++){
                            if(data[i]['flag'] === 1){
                                this.departmentList.push({
                                    "label": data[i]['name'],
                                    "value": data[i]['name']
                                })
                            }
                        }
                    }
                })
            await this.$mainApi.get('api/other-details/processor?type=driver')
                .then(response => {
                    if(response.data.status === 80){
                        let data = response.data.details.returnData
                        for(let i=0;i<data.length;i++){
                            if(data[i]['flag'] === 1){
                                this.driverList.push({
                                    "label": data[i]['name'] + ' (' + data[i]['phone'] + ')',
                                    "value": data[i]['id']
                                })
                            }
                        }
                    }
                })
        },
        setDate(){
            let now = new Date()
            const offset = now.getTimezoneOffset()
            now = new Date(now.getTime() - (offset*60*1000))
            this.getStockOutDate = now.toISOString().substring(0,10)
        }
    },
    mounted() {
        document.title = this.$t('title') + ' | ' + this.$t('inventory_stock_out')

        this.getBackendData()
        this.setDate()
        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            data: [],
            columns: [
                {title: "pid", field: 'pid', visible: false},
                {title: "lid", field: 'lid', visible: false},
                {title: "id", field: 'id', resizable: false, sorter: 'number', width: 10, responsive: 0,},
                {
                    title: this.$t('product_outCode_short'), field: 'outCode', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 250, width: 250,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('product_innerCode'), field: 'innerCode', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 150, width: 250,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('product_product_en'), field: 'product_name', sorter: 'string', resizable: true,
                    responsive: 1, minWidth: 250, width: 250,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_location'), field: 'location_name', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_qty'), field: 'qty', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_ctn'), field: 'ctn', sorter: 'string', resizable: true,
                    responsive: 1,widthGrow: 1,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_remarks'), field: 'remarks', sorter: 'string', resizable: false,
                    responsive: 1, minWidth: 300, width: 300,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    formatter: () => {
                        return "<i class='bi bi-pencil-fill'></i>"
                    },
                    headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                    headerSort: false, width: 10, responsive: 0,
                    cellClick: (e, row, formatterParams) => {
                        this.updateMode = true
                        this.needReloadList = false
                        this.updateItemID = row.getData().id
                        this.$refs.filterDetailContentBox.updateModeChange(row.getData().outCode)
                        this.$refs.stockCalculatedLocationBox.updateMode({
                            "pid": row.getData().pid,
                            "lid": row.getData().lid,
                            "sid": this.getStockOutID
                        })
                        this.$refs.qtyProcessor.updateModeOnQty({
                            "qty": row.getData().qty,
                            "ctn": row.getData().ctn
                        })
                        this.getQty = row.getData().qty
                        this.getCtn = row.getData().ctn
                        this.getRemarks = row.getData().remarks
                    }
                },
                {
                    formatter: () => {
                        return "<i class='bi bi-trash-fill'></i>"
                    },
                    headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                    headerSort: false, width: 10, responsive: 0,
                    cellClick: (e, row, formatterParams) => {
                        this.$swal.fire({
                            title: this.$t('common_confirm_action_delete'),
                            icon: 'info'
                        }).then(result => {
                            if(result.isConfirmed){
                                let data = this.tabulator.getData()
                                data = data.filter(a => a.id !== row.getData().id)
                                this.tabulator.setData(data)
                            }
                        })
                    }
                },
            ],
            reactiveData: true, //enable data reactivity
            maxHeight: '90vh',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns: true,
            movableRows: false,
            initialSort: [
                {column: "id", dir: "desc"},
            ],
            rowFormatter: (row, e) => {
                if (row.getData().is_error === true) {
                    row.getElement().style.backgroundColor = "#fac3c3"
                }
            }
        })
    }
}
</script>

<style scoped>

</style>
